import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { stringSchema } from '../../helpers';

export const educationFormSchema = yup
  .object({
    educationDetails: yup
      .array()
      .of(
        yup.object({
          institutionName: stringSchema(),
          specialtyName: stringSchema(),
          graduationYear: yup
            .string()
            .required(i18n.t('COMMON:errors.required')),
        })
      )
      .required(i18n.t('COMMON:errors.required'))
      .min(1, i18n.t('COMMON:errors.required')),
  })
  .required();
